import { useCallback, useMemo } from 'react';

import { useHistory } from 'react-router-dom';

import { generateOrderDetailsUrlFromSearchAndPath } from '../../../store/orders/order-details/orders.details.helpers';

export const useOrderDetailsNavigation = (previousSalesOrderId, previousFulfillmentPlanId, nextSalesOrderId, nextFulfillmentPlanId) => {
  const history = useHistory();
  const currentPathName = history.location.pathname;
  const currentSearch = history.location.search;

  const goToPreviousOrder = useCallback(() => {
    history.push(generateOrderDetailsUrlFromSearchAndPath(currentSearch, currentPathName, previousFulfillmentPlanId, previousSalesOrderId));
  }, [currentPathName, currentSearch, history, previousFulfillmentPlanId, previousSalesOrderId]);

  const goToNextOrder = useCallback(() => {
    history.push(generateOrderDetailsUrlFromSearchAndPath(currentSearch, currentPathName, nextFulfillmentPlanId, nextSalesOrderId));
  }, [currentPathName, currentSearch, history, nextFulfillmentPlanId, nextSalesOrderId]);

  return useMemo(
    () => ({
      goToPreviousOrder: previousSalesOrderId ? goToPreviousOrder : null,
      goToNextOrder: nextSalesOrderId ? goToNextOrder : null,
    }),
    [goToNextOrder, goToPreviousOrder, nextSalesOrderId, previousSalesOrderId],
  );
};
